export const GET_TRANSACTION = 'transaction/get';
export const GET_TRANSACTION_SUCCESS = 'transaction/get/success';
export const GET_TRANSACTION_FAIL = 'transaction/get/fail';

export const CLEAR_TRANSACTIONS_STATE = 'CLEAR_TRANSACTIONS_STATE';
